/**
 * Константы с урлами
 */
export const urls = {
    'fpc-dm-aggregate-recovery-exports-tasks': 'https://functions.yandexcloud.net/d4eh8pvrtm9n3ga6a7pf',
};
